import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useLikes() {
  const queryLikes = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/users/likes/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const createLike = async (userId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/users/${userId}/likes`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  const deleteLike = async (userId, workId) => {
    const result = await axios.delete(
      `${apiUri}/api/v1/users/${userId}/likes/${workId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return result.data?.data;
  };

  const getLikes = async (userId) => {
    const result = await axios.get(`${apiUri}/api/v1/users/${userId}/likes`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data?.data;
  };

  return {
    queryLikes: queryLikes,
    createLike,
    deleteLike,
    getLikes,
  };
}
